import { AnimatePresence, motion } from "framer-motion";
import { PropsWithChildren } from "react";

type UpdateKey = string | number | boolean;
type RanaPageTransitionProps =
  | {
      updateKey: UpdateKey;
      visible?: boolean;
    }
  | {
      updateKey?: UpdateKey;
      visible: boolean;
    };

export const RanaPageTransition = ({
  children,
  visible = true,
  updateKey = visible,
}: PropsWithChildren<RanaPageTransitionProps>) => {
  return (
    <AnimatePresence mode="wait" initial={false}>
      {visible && (
        <motion.div
          key={updateKey + ""}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
